import { createContext } from 'react'
import { theme } from '../../../config/theme'
import { ThemeType } from '../../../types/theme/themeType'

export const OldThemeContext = createContext<ThemeType>(theme)
